module.exports = __webpack_public_path__ + "img/maintenance_plan.7886e135.svg";